import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { IDay, Store } from '@df/catalog/store/store';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { HourFormat12Pipe } from '@df/ui/display/hour-format-12.pipe';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import sortBy from 'lodash-es/sortBy';
import { StoreOpenStatusComponent } from '../store-open-status/store-open-status.component';

@Component({
    selector: 'store-details',
    templateUrl: './store-details.html',
    styleUrl: './store-details.scss',
    standalone: true,
    imports: [CommonModule, DfImageDirective, HourFormat12Pipe, StoreOpenStatusComponent, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StoreDetailsComponent implements OnChanges {
    @Input() store?: Store;

    weeklySchedule: IDay[] = [];

    ngOnChanges(): void {
        this.weeklySchedule = this.getWeeklySchedule();
    }

    //returns 7 upcoming store opening days with details
    private getWeeklySchedule(): IDay[] {
        const openingHours = this.store?.openingHours;
        if (openingHours?.length) {
            const weeklySchedule = sortBy(openingHours.slice(0, 7), day => day.date && day.date.getDay());
            weeklySchedule.push(weeklySchedule.shift());
            return weeklySchedule;
        }
        return [];
    }
}
